import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RecentActivitiesSectionProps } from './types';
import { SECTION_TITLES, LABELS, ACTIVITY_ICON_MAP } from './constants';
import { getStatusColor } from './utils';
import {
  SectionCard,
  SectionHeader,
  SectionTitle,
  RefreshArea,
  LiveBadge,
  RefreshButton,
  ActivitiesContainer,
  ActivityItem,
  ActivityLeft,
  ActivityIconWrapper,
  ActivityTextGroup,
  ActivityText,
  ActivitySubtext,
  ActivityTime,
  EmptyText,
} from './styles';

const RecentActivitiesSection: React.FC<RecentActivitiesSectionProps> = ({
  activities,
  isLoading,
  onRefresh,
}) => {
  return (
    <SectionCard>
      <SectionHeader>
        <SectionTitle>{SECTION_TITLES.RECENT_ACTIVITIES}</SectionTitle>
        <RefreshArea>
          <LiveBadge color="success">{LABELS.LIVE}</LiveBadge>
          <RefreshButton
            type="primary"
            ghost
            size="small"
            onClick={onRefresh}
            loading={isLoading}
          >
            {LABELS.REFRESH}
          </RefreshButton>
        </RefreshArea>
      </SectionHeader>

      {activities.length > 0 ? (
        <ActivitiesContainer>
          {activities.map((activity) => {
            const icon = ACTIVITY_ICON_MAP[activity.iconKey] || ACTIVITY_ICON_MAP.default;
            const statusColor = getStatusColor(activity.status);
            const typeLabel = activity.type
              ? `${activity.type.charAt(0).toUpperCase() + activity.type.slice(1)} activity`
              : 'System activity';

            return (
              <ActivityItem key={activity.id} $statusColor={statusColor}>
                <ActivityLeft>
                  <ActivityIconWrapper $color={statusColor}>
                    <FontAwesomeIcon icon={icon} />
                  </ActivityIconWrapper>
                  <ActivityTextGroup>
                    <ActivityText>{activity.action}</ActivityText>
                    <ActivitySubtext>{typeLabel}</ActivitySubtext>
                  </ActivityTextGroup>
                </ActivityLeft>
                <ActivityTime>{activity.time}</ActivityTime>
              </ActivityItem>
            );
          })}
        </ActivitiesContainer>
      ) : (
        <EmptyText>{LABELS.NO_ACTIVITIES}</EmptyText>
      )}
    </SectionCard>
  );
};

export default RecentActivitiesSection;
